import { useHmo } from '@hook'
import { DeleteModal } from '@ui'
import { getError, showToast } from '@util'
import { useState } from 'react'

type Props = {
  id?: string
  onClose: () => void
}

export const RemoveHmo = ({ onClose, id }: Props) => {
  const { deleteHmo } = useHmo()
  const [isLoading, setIsLoading] = useState(false)

  const handleDelete = async () => {
    setIsLoading(true)
    try {
      await deleteHmo({ id: id || '' })
      onClose()
      showToast('Hmo deleted successfully')
      setIsLoading(false)
    } catch (error) {
      getError(error)
    } finally {
      setIsLoading(false)
    }
  }
  return (
    <DeleteModal
      description="Confirm that you want to delete this HMO"
      handleSubmit={handleDelete}
      isLoading={isLoading}
      onClose={onClose}
      title="Delete HMO"
    />
  )
}
